import {useMutation} from "@tanstack/react-query";
import {message} from "antd";
import {httpClientV2} from "../../../../infrastructure/http";

export type ExportSubscriptionCustomerPurchasesCsvParams = {
  subscriptionId: number;
  startDate: string;
  endDate: string;
};

function formatExportError(error: unknown): string {
  if (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof (error as {message?: unknown}).message === "string"
  ) {
    return (error as {message: string}).message;
  }
  return "Could not export subscriber data.";
}

/**
 * CSV export: `GET analytics/subscriptions/customer-purchases/export/:subscriptionId?startDate=&endDate=`
 */
export function useExportSubscriptionCustomerPurchasesCSV() {
  return useMutation<Blob, unknown, ExportSubscriptionCustomerPurchasesCsvParams>({
    mutationFn: async ({subscriptionId, startDate, endDate}) => {
      const params = new URLSearchParams({
        startDate,
        endDate,
      });

      return httpClientV2.get<Blob>(
        `analytics/subscriptions/customer-purchases/export/${subscriptionId}?${params}`,
        {responseType: "blob"}
      );
    },
    onError: (error) => {
      message.error(formatExportError(error));
    },
  });
}
